
import { defineComponent } from 'vue'
import { shortenLargeNumber } from '~/utils/string'

export default defineComponent({
  name: 'OccurrenceTags',
  props: {
    total: {
      type: Number,
      required: true
    },
    high: {
      type: Number,
      default: 0
    },
    medium: {
      type: Number,
      default: 0
    },
    low: {
      type: Number,
      default: 0
    }
  },
  methods: {
    shortenLargeNumber
  }
})
